import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IVideoLayer, VideoLayerPlaybackStrategyEnum } from '../../../models/project/take/layers/video-layer-model';
import {
    IStagePositionsExtended,
    IStagePositionWithConfigs,
    StagePositionDirectionsEnum,
} from '../../../models/defines';
import { ILocalWithIsDisabled } from '../../../pages/private/dashboard/project/shared-components/video-layer-setup/video-layer-setup.component';

@Injectable()
export class StudioVideoLayerStateManagerService {
    private _currentVideoLayerSubject = new BehaviorSubject<IVideoLayer>(null);
    public currentVideoLayer$ = this._currentVideoLayerSubject.asObservable();

    private _currentStagePositionSubject = new BehaviorSubject<IStagePositionsExtended>(null);
    public currentStagePosition$ = this._currentStagePositionSubject.asObservable();

    constructor() {}

    public setCurrentVideoLayer(videoLayer: IVideoLayer) {
        this._currentVideoLayerSubject.next(videoLayer);
    }

    public getCurrentVideoLayer() {
        return this._currentVideoLayerSubject.getValue();
    }
    public getCurrentStagePosition() {
        return this._currentStagePositionSubject.value;
    }

    public setCurrentStagePosition(stagePosition: IStagePositionsExtended) {
        this._currentStagePositionSubject.next(stagePosition);
    }
}
